import React from "react";
import "./SkipButtons.css";

const SkipForward = ({ onSkipForward }) => {
  return (
    <div className="controls">
      <button onClick={onSkipForward} className="wind">
        <svg
          width="40"
          height="41"
          viewBox="0 0 40 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24.88 1.49213L29.2063 8.98566L21.7128 13.312M34.465 18.5554C34.9823 21.8004 34.376 25.1249 32.7462 27.9783C31.1164 30.8318 28.561 33.043 25.5031 34.246C22.4452 35.4491 19.0681 35.5717 15.9309 34.5935C12.7938 33.6154 10.0848 31.5952 8.25246 28.8675C6.42009 26.1397 5.57425 22.868 5.85497 19.5939C6.1357 16.3199 7.52615 13.2399 9.79612 10.8639C12.0661 8.48785 15.0794 6.95833 18.3373 6.52852C21.5951 6.09871 24.9021 6.7944 27.7106 8.50041"
            stroke="#A0A3B1"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.4485 25.5083H15.0305V18.6587L12.9387 19.3735V18.1724L16.2668 16.9478H16.4485V25.5083ZM19.7942 21.2778L20.2571 16.9771H24.8391V18.2075H21.4407L21.2063 20.2466C21.6008 20.02 22.0461 19.9067 22.5422 19.9067C23.3547 19.9067 23.9856 20.1665 24.4348 20.686C24.8879 21.2056 25.1145 21.9048 25.1145 22.7837C25.1145 23.6509 24.8645 24.3423 24.3645 24.8579C23.8645 25.3696 23.179 25.6255 22.3079 25.6255C21.5266 25.6255 20.8782 25.4048 20.3625 24.9634C19.8508 24.5181 19.5735 23.9321 19.5305 23.2056H20.9075C20.9622 23.6196 21.1106 23.938 21.3528 24.1606C21.595 24.3794 21.9114 24.4888 22.302 24.4888C22.7395 24.4888 23.0793 24.3325 23.3215 24.02C23.5676 23.7075 23.6907 23.2817 23.6907 22.7427C23.6907 22.2231 23.5559 21.813 23.2864 21.5122C23.0168 21.2075 22.6458 21.0552 22.1731 21.0552C21.9153 21.0552 21.6965 21.0903 21.5168 21.1606C21.3372 21.2271 21.1418 21.3599 20.9309 21.5591L19.7942 21.2778Z"
            fill="#A0A3B1"
          />
        </svg>
      </button>
    </div>
  );
};

export default SkipForward;
